import { AlertTriangle } from "lucide-react";
import { useOpeningExceptions } from "@/hooks/useOpeningExceptions";
import { useNavigate, useLocation } from "react-router-dom";

export default function OpeningExceptionBanner() {
  const { data: exceptions = [] } = useOpeningExceptions();
  const navigate = useNavigate();
  const location = useLocation();

  if (exceptions.length === 0) return null;

  const handleClick = () => {
    if (location.pathname === "/") {
      const el = document.getElementById("tiedotteet");
      el?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/#tiedotteet");
    }
  };

  return (
    <div className="bg-amber-500/10 border border-amber-500/30 rounded-lg px-4 py-3 flex items-center justify-between gap-3 mt-4">
      <div className="flex items-center gap-2">
        <AlertTriangle size={16} className="text-amber-500 shrink-0" />
        <span className="text-sm font-medium text-amber-400">Aukioloissa poikkeus</span>
      </div>
      <button
        onClick={handleClick}
        className="text-xs font-semibold text-amber-500 hover:text-amber-400 transition-colors underline underline-offset-2 shrink-0"
      >
        Lue lisää
      </button>
    </div>
  );
}
